import { render, staticRenderFns } from "./TravelListItems.vue?vue&type=template&id=33e6e56e&scoped=true&"
import script from "./TravelListItems.vue?vue&type=script&lang=js&"
export * from "./TravelListItems.vue?vue&type=script&lang=js&"
import style0 from "./TravelListItems.vue?vue&type=style&index=0&id=33e6e56e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e6e56e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VIcon,VListItem,VListItemAction,VListItemContent,VListItemSubtitle,VListItemTitle})
